import logger from '../utils/logger';
import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={() => {
        logger.log('Toggle clicked! Current theme:', theme);
        toggleTheme();
      }}
      className="p-2 text-theme-tertiary hover:text-theme-primary"
      title={`Passer en mode ${theme === 'dark' ? 'clair' : 'sombre'}`}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun className="w-4 h-4" strokeWidth={1.5} />
      ) : (
        <Moon className="w-4 h-4" strokeWidth={1.5} />
      )}
    </button>
  );
};

export default ThemeToggle;
